import { render, staticRenderFns } from "./mbtiSet.vue?vue&type=template&id=059a7e61&scoped=true&"
import script from "./mbtiSet.vue?vue&type=script&lang=js&"
export * from "./mbtiSet.vue?vue&type=script&lang=js&"
import style0 from "./mbtiSet.vue?vue&type=style&index=0&id=059a7e61&prod&lang=scss&scoped=true&"
import style1 from "./mbtiSet.vue?vue&type=style&index=1&id=059a7e61&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a7e61",
  null
  
)

export default component.exports